import config from "config";
import config_textual_search from "./config_textual_search";
import config_graphical_search from "./config_graphical_search";
// Don't modify it, just copy it from
// /server/rest/services/GInfo/TextualSearch/MapServer?f=pjson
let TEXTUAL_SEARCH_LAYER_NAME = [
  {
    id: 0,
    name: "Man-made Features",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 1,
    name: "Eng Road Name",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 2,
    name: "Chi Road Name",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 3,
    name: "Lot Number",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 4,
    name: "License",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 5,
    name: "Lamp Post",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 6,
    name: "Active Sites - Districts",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 7,
    name: "Active Sites - Civil Engineering Projects",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 8,
    name: "Active Sites - LPM",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 9,
    name: "Blasting Sites",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 10,
    name: "Boulder",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 11,
    name: "CEDD - TGLA",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 12,
    name: "DH Files",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 13,
    name: "DH Cases",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 14,
    name: "DH Orders",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 15,
    name: "Advisory Letter Cases",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 16,
    name: "Advisory Letters Type 1 & 2",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 17,
    name: "Advisory Letters Type 3 & 4",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 18,
    name: "Advisory Projects",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 19,
    name: "Private Projects",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 20,
    name: "Public Projects",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 21,
    name: "ENTLI Crown",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 22,
    name: "ENTLI Trail",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolyline",
  },
  {
    id: 23,
    name: "Feature Status Review",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 24,
    name: "Slope Checking Status",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 25,
    name: "GCC Cases",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 26,
    name: "Borehole",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 27,
    name: "Historical Landslide Catchment",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 28,
    name: "Incidents (Confirmed Cases)",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 29,
    name: "Incidents (To be confirmed by LIC)",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPoint",
  },
  {
    id: 31,
    name: "Land Matter",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 32,
    name: "Landslide Studies Report Areas",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 33,
    name: "Map Sheet",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 34,
    name: "LPM Stage 2(H) Study",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 35,
    name: "LPM Stage 3(H) Study",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 36,
    name: "NT Exempted House",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 37,
    name: "NTHS (District)",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 38,
    name: "Tension Crack",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolyline",
  },
  {
    id: 39,
    name: "Tunnel Submission Records",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 40,
    name: "Unauthorized Slope Works",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 41,
    name: "Hillside Pocket",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 42,
    name: "18 Districts",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 43,
    name: "District Engineer Area",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 44,
    name: "Mitigated Hillside (MH) Features",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 45,
    name: "Advisory Letter",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 46,
    name: "DBEL",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 47,
    name: "Registered Squatter Dwelling - with CAF in force",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 48,
    name: "Geotechnical Clauses (Recommended by GEO)",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
  {
    id: 49,
    name: "Geotechnical Clauses (Executed by DLO)",
    parentLayerId: -1,
    defaultVisibility: false,
    subLayerIds: null,
    minScale: 0,
    maxScale: 0,
    type: "Feature Layer",
    geometryType: "esriGeometryPolygon",
  },
];

let allowExportToPDF = [
  "Advisory Letter",
  "Advisory Letter Case",
  "Advisory Project",
  "Boulder",
  "Bulk Excavation Limit",
  "Active Sites - Civil Engg. Project",
  "Dangerous Road Sign",
  "Squatter Warning Sign",
  "Pending for LPMit Works Sign",
  "Debris Flow Keep Clear Sign",
  "DH Order",
  "DH Case",
  "DH File",
  "District Engineer Area",
  "Disused Tunnel",
  "ENTLI Crown / Trail",
  "Feature Status Review",
  "GCC Case",
  "Hillside Pocket Catalogue (HPC)",
  "Historical Landslide Catchment",
  "Incident",
  "Incident to be confirmed",
  "Registered Squatter Dwelling - with CAF in force",
  "Squatter Structure - close to slope",
  "Landslide Studies Report Area",
  "LPM Emergency Works Services",
  "Active Sites - LPM",
  "Stage 2(H) Study",
  "LPM Stage 2 / 3 Study",
  "Stage 3(H) Study",
  "LPM Works Upgrading Boundary",
  "RISC Form",
  "SCRR",
  "NT Exempted House",
  "NTHS (District)",
  "Planning Comment",
  "Private Project",
  "Public Project",
  "Ground Anchor",
  "Horizontal Drain",
  "Land Matter",
  "Slope Checking Status",
  "Tension Crack",
  "TGLA",
  "Tunnel Submission Record",
  "Unauthorized Slope Works",
  "Strategic Cavern Areas",
  "Antiquities and Monuments",
  "Actives Site - Polygon",
  "CEDD - TGLA",
  // "Geotechnical Clauses - Recommended by GEO",
  // "Geotechnical Clauses - Executed by DLO",
];

let config_zoomto = {
  allowExportToPDF,
  TEXTUAL_SEARCH_LAYER_NAME,
  Search_Input_Values: {
    textual_dropdown_02: Array.apply(null, Array(16)).map((i, j) => j + 1),
    textual_dropdown_03: [
      "NE-A",
      "NE-B",
      "NE-C",
      "NE-D",
      "NW-A",
      "NW-B",
      "NW-C",
      "NW-D",
      "SE-A",
      "SE-B",
      "SE-C",
      "SE-D",
      "SW-A",
      "SW-B",
      "SW-C",
      "SW-D",
    ],
    textual_dropdown_04: [
      "C  ",
      "CR ",
      "F  ",
      "FR ",
      "R  ",
      "DT ",
      "NS ",
      "ND ",
    ],
    textual_dropdown_uav_years: Array.apply(
      null,
      new Array(new Date().getFullYear() - 2010 + 1)
    )
      .map((i, j) => j + 2010)
      .reverse(),
  },
  TEXUAL_SEARCH_LAYER_URL:
    config.serverUrl + "/rest/services/GInfo/TextualSearch/MapServer",
  TEXTUAL_SEARCH_LIST: config_textual_search,
  GRAPHICAL_SEARCH_LIST: config_graphical_search,
};
export default config_zoomto;
